
import { FC } from 'react';
import Header from '../../components/feature/Header';
import HeroSection from '../../components/feature/HeroSection';
import AboutSection from '../../components/feature/AboutSection';
import MenuSection from '../../components/feature/MenuSection';
import LocationSection from '../../components/feature/LocationSection';
import ReservationSection from '../../components/feature/ReservationSection';
import Footer from '../../components/feature/Footer';

const HomePage: FC = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <MenuSection />
        <LocationSection />
        <ReservationSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
